
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import MobileCallButton from '../../components/feature/MobileCallButton';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      {/* Floating transparent background logo */}
      <div className="fixed inset-0 z-0 flex items-center justify-center pointer-events-none">
        <img
          src="https://static.readdy.ai/image/69b3c4875e1562fa68a140ce2d237389/644ca808ee069ab97d6a9bc1f4617fe7.png"
          alt=""
          className="w-[900px] h-auto opacity-[0.08]"
        />
      </div>
      
      <Navigation isScrolled={isScrolled} />
      <MobileCallButton />
      <Hero />
      <About />
      <Testimonials />
      <Footer />
    </div>
  );
}
